// extracted by mini-css-extract-plugin
export default {"container":"TextContent_container__5CJox","underline":"TextContent_underline__U6pwq","previewItem":"TextContent_previewItem__YUFR0","apyText":"TextContent_apyText__vk+Bc"};